// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"08b0308d","191":"871b8f5e","793":"e51039ea","925":"95f2a0e5"}[chunkId] + ".chunk.css";
};